<div class="pagination-footer" *ngIf="total > 0">
  <!-- Full mode: info row -->
  <div class="pagination-info" *ngIf="showInfo && mode === 'full'">
    <span>Showing {{ showingFrom }}–{{ showingTo }} of {{ total }}<ng-container *ngIf="itemLabel"> {{ itemLabel }}</ng-container></span>
  </div>

  <!-- Full mode controls -->
  <nav class="pagination-controls" aria-label="Pagination" *ngIf="mode === 'full'">
    <button type="button" class="page-btn" (click)="first()" [disabled]="page === 1" aria-label="First page">&laquo;</button>
    <button type="button" class="page-btn" (click)="prev()" [disabled]="page === 1" aria-label="Previous page">&lsaquo;</button>
    <span class="page-indicator">Page {{ page }} of {{ totalPages || 1 }}</span>
    <button type="button" class="page-btn" (click)="next()" [disabled]="page === totalPages || totalPages === 0" aria-label="Next page">&rsaquo;</button>
    <button type="button" class="page-btn" (click)="last()" [disabled]="page === totalPages || totalPages === 0" aria-label="Last page">&raquo;</button>
  </nav>

  <!-- Simple mode controls -->
  <nav class="pagination-controls" aria-label="Pagination" *ngIf="mode === 'simple'">
    <button type="button" class="page-btn" (click)="prev()" [disabled]="page === 1" aria-label="Previous page">&lsaquo;</button>
    <span class="page-indicator">Page {{ page }} of {{ totalPages || 1 }}</span>
    <button type="button" class="page-btn" (click)="next()" [disabled]="page === totalPages || totalPages === 0" aria-label="Next page">&rsaquo;</button>
  </nav>

  <!-- Full mode: page size selector -->
  <div class="page-size" *ngIf="showPageSize && mode === 'full'">
    <label>Per page</label>
    <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
      <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
    </select>
  </div>
</div>
